import { DivineControlEvent } from "../../DivineControlEventBase.js";
export class DCBaseMouseEvent extends DivineControlEvent {
    eventType = "mouse-down";
    inputType = "mouse";
    constructor() {
        super();
    }
    getButton() {
        return this.getData().button;
    }
}
